import APIRequest from './core/Request';
// API Compoenents
import APIUser from './operations/APIUser';
import APITenant from './operations/APITenant';
import APICourse from './operations/APICourse';
import APICourseFile from './operations/APICourseFile';
import APICertification from './operations/APICertification';
import APIOrganization from './operations/APIOrganization';
import APIAffiliate from './operations/APIAffiliate';
import APIPendingApplications from './operations/APIPendingApplications';
import APIApplication from './operations/APIApplication';
import APIApplicationItem from './operations/APIApplicationItem';
import APIApplicationItemFile from './operations/APIApplicationItemFile';
import APIApplicationDownload from './operations/APIApplicationDownload';
import APIDashboard from './operations/APIDashboard';
//
export default class Client {
  /* config structure
    {
      endpoint: LMSAPIEndpoint, statsEndpoint: LMSStatsEndpoint,
      authorizationToken: '', -- optional, IDM JWT for shared module admins and user routes -- Accepts a function to be called async and return the token
      tenantID: '', customerID: ''
    }
  */
  constructor(config) {
    this.config = config;
    // api operations
    this.user = new APIUser(this);
    this.certification = new APICertification(this);
    this.course = new APICourse(this);
    this.courseFile = new APICourseFile(this);
    this.tenant = new APITenant(this);
    this.organization = new APIOrganization(this);
    this.affiliate = new APIAffiliate(this);
    this.pendingApplications = new APIPendingApplications(this);
    this.application = new APIApplication(this);
    this.applicationItem = new APIApplicationItem(this);
    this.applicationItemFile = new APIApplicationItemFile(this);
    this.dashboard = new APIDashboard(this);
  }
  /* Public */
  async newBaseRequest(method) {
    const req = new APIRequest(method);
    //Auth
    if (this.config.authorizationToken) {
      let token = this.config.authorizationToken;
      if (typeof this.config.authorizationToken === "function") {
        token = await this.config.authorizationToken();
      }
      req.appendHeader('Authorization', token);
    }
    if (this.config.tenantID) req.appendHeader('tenantID', this.config.tenantID);
    if (this.config.customerID) req.appendHeader('customerID', this.config.customerID);
    //
    req.baseURL = this.config.endpoint;
    if (this.config.port) req.baseURL += `:${this.config.port}`;
    //
    return req;
  }
  async newApplicationDownload(certProc, foreignItems, certSpecs, applicationType) {
    return (new APIApplicationDownload(this, certProc, foreignItems, certSpecs, applicationType)).download();
  }
}
